import { Checkbox } from '@library/components/inputs';
import type { Correlation } from '@library/types/correlations';

import { DateTime } from 'luxon';
import { formatWithTimezoneChange } from '@library/utils/dateTime';

export interface ViewCorrelationsRowProps {
  correlation: Correlation;
}

export const ViewCorrelationsRow = ({
  correlation
}: ViewCorrelationsRowProps) => {
  const {
    id,
    approvedBy,
    correlationId,
    firstChoice,
    firstPosition,
    firstStatType,
    isSameTeam,
    lastModifiedUserName,
    probability,
    requestedBy,
    secondChoice,
    secondPosition,
    secondStatType,
    updatedAt
  } = correlation;

  const lastUpdatedAt = formatWithTimezoneChange(
    DateTime.fromISO(updatedAt),
    'LL/dd/yyyy • t ZZZZ'
  );

  return (
    <tr className="text-soClean-100 placeholder:text-soClean-140 border-soFresh-140 border-t">
      <td className="py-5 pl-4">
        <div className="w-56 overflow-scroll sm:text-sm sm:leading-6">
          {correlationId}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-20 overflow-scroll sm:text-sm sm:leading-6">
          {firstPosition}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-56 overflow-scroll sm:text-sm sm:leading-6">
          {firstStatType}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-28 overflow-scroll sm:text-sm sm:leading-6">
          {firstChoice}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-20 overflow-scroll sm:text-sm sm:leading-6">
          {secondPosition}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-56 overflow-scroll sm:text-sm sm:leading-6">
          {secondStatType}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-28 overflow-scroll sm:text-sm sm:leading-6">
          {secondChoice}
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-14 sm:text-sm sm:leading-6">{probability}</div>
      </td>
      <td className="py-5 pl-4">
        <div className="w-24 pl-6">
          <Checkbox
            checked={isSameTeam}
            disabled
            id={`${id}-isSameTeam`}
            onCheckboxChange={() => {}}
          />
        </div>
      </td>
      <td className="py-5 pl-4">
        <div className="h-9 w-40 sm:text-sm sm:leading-6">{requestedBy}</div>
      </td>
      <td className="py-5 pl-4">
        <div className="h-9 w-40 sm:text-sm sm:leading-6">{approvedBy}</div>
      </td>
      <td className="h-9 w-40 py-5 pl-4">
        <div className="w-40 overflow-scroll sm:text-sm sm:leading-6">
          {lastModifiedUserName}
        </div>
      </td>
      <td className="h-9 w-40 py-5 pl-4">
        <div className="w-56 overflow-scroll sm:text-sm sm:leading-6">
          {lastUpdatedAt}
        </div>
      </td>
      {/* <td className="h-9 py-5 pl-4" /> */}
    </tr>
  );
};
